import React, { Fragment } from 'react'
import { StyledGreenIcon, StyledRedIcon, CenterText } from './styles'

const Verified = () => (<StyledGreenIcon />)

const Unverified = ({ code }) => (
  <Fragment>
    <StyledRedIcon />
    <CenterText>{code}</CenterText>
  </Fragment>
)

const PosterCheck = (props) => {
  const { posterCheck } = props
  if (!posterCheck || !posterCheck.length) return null
  return (
    <CenterText>
      {posterCheck[0].status === 'verified'
        ? (<Verified />)
        : posterCheck[0].status === 'unverified' ? (<Unverified code={posterCheck[0].code} />) : null
      }
    </CenterText>
  )
}

export default PosterCheck
